import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { History } from 'lucide-react';

const ENTITY_LABEL = { shift: 'Shift', service_allocation: 'Service segment', shared_delivery_group: 'Shared delivery group', billing_records: 'Billing record' };
export const eventLabel = (action) => String(action || '').replace(/[._]/g, ' ').toLowerCase().replace(/^\w/, (c) => c.toUpperCase());

/** UI-11 (§58) — audit events for this shift, newest first, via the read-only GET /roster/shifts/{id}/audit. */
export function ShiftHistoryTab({ shift }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!shift?.id) return undefined;
    let alive = true;
    api.get(`/roster/shifts/${shift.id}/audit`).then((r) => { if (alive) setRows(r.data?.data || []); })
      .catch((e) => { if (alive) { setRows([]); setError(e?.response?.data?.detail?.message || e?.response?.data?.detail || 'Could not load history'); } });
    return () => { alive = false; };
  }, [shift?.id]);
  return (
    <div className="rounded-lg border bg-card p-3 space-y-2" data-testid="shift-history-tab">
      <div className="text-sm font-semibold flex items-center gap-2"><History className="w-4 h-4" /> History</div>
      {rows === null && <div className="text-xs text-muted-foreground">Loading…</div>}
      {error && <div className="text-xs text-red-700" data-testid="shift-history-error">{typeof error === 'string' ? error : 'Could not load history'}</div>}
      {rows && rows.length === 0 && !error && <div className="text-xs text-muted-foreground" data-testid="shift-history-empty">No recorded events for this shift yet.</div>}
      {(rows || []).map((r) => (
        <div key={r.id} className="text-xs border-l-2 border-slate-200 pl-2 py-0.5" data-testid="shift-history-row">
          <div className="flex justify-between gap-2"><span className="font-medium">{eventLabel(r.action)}</span><span className="text-muted-foreground tabular-nums shrink-0">{r.timestamp ? new Date(r.timestamp).toLocaleString('en-AU', { timeZone: 'Australia/Brisbane', dateStyle: 'short', timeStyle: 'short' }) : ''}</span></div>
          <div className="text-[10px] text-muted-foreground">{ENTITY_LABEL[r.entity] || r.entity}{r.user_name ? ` · ${r.user_name}` : ''}{r.meta?.reason ? ` · ${r.meta.reason}` : ''}</div>
        </div>
      ))}
    </div>
  );
}

export default ShiftHistoryTab;
